import { NgModule } from '@angular/core';
import { ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
  imports: [
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath: '../public/i18n-assets/{{lng}}/{{ns}}.json',
        },

        chunks: {
          custom: [
            'newsArticles',
            'mobileNav',
            'banner',
            'productCarousel',
            'cookieConsent',
            'product',
            'cart',
            'download',
            'termsConditions',
            'pdpManual',
            'voucher',
            'checkout',
            'orderConfirmation',
            'myAccount',
            'login',
            'csvImport',
            'requestAccount',
            'forgotPassword',
            'resetPassword',
            'variant',
            'orders',
            'orderForm',
            'error',
            'changePasswordForm',
            'unitSelection',
            'dealer',
            'customerService',
            'discounts',
            'personalInfo',
            'customSearch',
            'buttonTooltip',
            'moq',
            'explodedView',
            'businessLicense',
            'tooltip',
            'gst',
            'shimano',
            'exception',
            'fish',
            'modal',
          ],
          common: ['skipLink', 'searchBox', 'pageMetaResolver','httpHandlers'],
          product: ['stockNotification', 'itemCounter'],
          checkout: [
            'checkoutAddress',
            'checkoutOrderConfirmation',
            'checkoutReview',
            'checkoutShipping',
            'checkout',
            'checkoutProgres',
          ],
        },
      },
    }),
  ],
  providers: [],
})
export class ShimanoI18nModule {}
